import * as React from 'react';

import { FormField } from 'components/form';
import Input from 'components/inputs/input/Input';
import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';

import { __t, applyTranslations } from 'utils/language';
import {
  isFalsy,
  isGreaterThanZero,
  isNotEmpty,
  maxLength
} from 'utils/validators';
import {
  getCreatorNameWithTimelineOverlapForPostpone
} from 'modules/subcampaigns/utils/bulk-offer-validation';

import type { SyntheticEvent } from 'react';
import type { BulkOfferModalSelectedTimelines, BulkOfferModalSubcampaignCustomOffer } from 'modules/subcampaigns/types/BulkOfferModal.type';

import './bulk-postpone-form.scss';

applyTranslations(require('./bulk-postpone-form.i18n.json'));

type Props = {
  pickedTimelines: BulkOfferModalSelectedTimelines,
  days: number,
  groupedDeliverables: Array<BulkOfferModalSubcampaignCustomOffer>,
  selectedDeliverableIds: Array<number>,
  isZalandoOutfitOnly: boolean,
  onTimelineSelect: (event: SyntheticEvent<HTMLInputElement>) => void,
  onDaysChange: (event: SyntheticEvent<HTMLSelectElement>) => void
};

const NUM_DAYS_CHAR_MAX = 4;
const MSG_KEY = 'bulk_postpone_form';

const BulkPostponeForm: React.FC<Props> = ({
  pickedTimelines,
  days,
  groupedDeliverables,
  selectedDeliverableIds,
  isZalandoOutfitOnly,
  onTimelineSelect,
  onDaysChange
}: Props) => {
  const erroredCreatorName = getCreatorNameWithTimelineOverlapForPostpone(
    groupedDeliverables,
    selectedDeliverableIds,
    pickedTimelines,
    days
  );

  return (
    <div className="bulk-postpone-form">
      <FormField
        label={__t(`${MSG_KEY}.label_apply_to`)}
        labelType="highlighted"
        showValidationIcon={false}
        direction="row"
        fontSize="small"
        className="bulk-postpone-form__entries"
        validators={[
          isNotEmpty(
            Object.values(pickedTimelines).some(picked => picked),
            __t(`${MSG_KEY}.errors.none_selected`)
          ),
          isFalsy(
            erroredCreatorName,
            __t(`${MSG_KEY}.errors.check_creator`, { erroredCreatorName })
          )
        ]}
      >
        <div className="bulk-postpone-form__checkboxes">
          <InputCheckbox
            name="type"
            value="contentApproval"
            label={__t(`${MSG_KEY}.label_content_approval`)}
            id="checkbox-filter--contentApproval"
            containerClass="bulk-postpone-form__checkbox-container"
            size="small"
            checked={pickedTimelines.contentApproval}
            onChange={onTimelineSelect}
          />
          {
            !isZalandoOutfitOnly && (
              <React.Fragment>
                <InputCheckbox
                  name="type"
                  value="goLive"
                  label={__t(`${MSG_KEY}.label_go_live`)}
                  id="checkbox-filter--goLive"
                  containerClass="bulk-postpone-form__checkbox-container"
                  size="small"
                  checked={pickedTimelines.goLive}
                  onChange={onTimelineSelect}
                />
                <InputCheckbox
                  name="type"
                  value="insightsProvision"
                  label={__t(`${MSG_KEY}.label_insights`)}
                  id="checkbox-filter--insights"
                  containerClass="bulk-postpone-form__checkbox-container"
                  size="small"
                  checked={pickedTimelines.insightsProvision}
                  onChange={onTimelineSelect}
                />
              </React.Fragment>
            )
          }
        </div>
      </FormField>
      <FormField
        label={__t(`${MSG_KEY}.label_days`)}
        labelType="highlighted"
        showValidationIcon={false}
        direction="row"
        fontSize="small"
        className="bulk-timeline-form__timeline-label"
        validators={[
          isNotEmpty(days, __t(`${MSG_KEY}.errors.empty_days`)),
          isGreaterThanZero(days),
          maxLength(String(days), NUM_DAYS_CHAR_MAX)
        ]}
      >
        <Input
          name="days"
          type="number"
          min={0}
          width="responsive"
          value={String(days || '')}
          onChange={onDaysChange}
        />
      </FormField>
    </div>
  );
};

export default BulkPostponeForm;
